import { faVolumeHigh as faVolumeSharp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '../../shared/components/button/Button';
import WhitePopUpWithLinks from '../../shared/modal/whitePopUp/WhitePopUpWithLinks';

export function CTA({ mediaType, mediaObject, activeDay, setActiveDay }) {
  const { t } = useTranslation();
  const [cta, setCta] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [indexToBePlayed, setIndexToBePlayed] = useState();

  const mediaUrl = useMemo(() => {
    if (
      mediaType === 'masterclass' &&
      (indexToBePlayed === null || indexToBePlayed === undefined)
    ) {
      return null;
    }

    switch (mediaType) {
      case 'programme':
        return `/programme/${mediaObject.chid}/${mediaObject.title.replace(/ /g, '_')}/day_${
          mediaObject.days.findIndex((day) => activeDay.title === day.title) + 1
        }`;
      case 'masterclass':
        return `/masterclass/${mediaObject.chid}/${mediaObject.title.replace(
          / /g,
          '_'
        )}/${indexToBePlayed + 1}/${mediaObject.chapters[indexToBePlayed].title
          .replace(/ /g, '_')
          .toLowerCase()}`;
      case 'take-actions':
        if (
          mediaObject.media?.category.toLowerCase() === 'programme' ||
          mediaObject.media?.category.toLowerCase() === 'masterclass'
        ) {
          return `/${mediaObject.media.category.toLowerCase().replace(/ /g, '_')}/${
            mediaObject.media.chid
          }/${mediaObject.title.replace(/ /g, '_')}`;
        }
        if (mediaObject.media?.chid) {
          return `/media/player/${mediaObject.media.chid}/${mediaObject.title.replace(/ /g, '_')}`;
        }
        return null;
      default:
        return `/media/player/${mediaObject.chid}/${mediaObject.title.replace(/ /g, '_')}`;
    }
  }, [mediaObject, indexToBePlayed, mediaType, activeDay]);

  const popUpContents = {
    title: t('M074W'),
    heading: `${t('M076W')}`,
    paragraphs: [t('M077W')],
    backBtn: {
      text: t('back.button'),
      handleClick: () => {
        setOpenPopUp(false);
      },
    },
    continueBtn: {
      text: t('M012'),
      link: mediaUrl ?? '/for-you',
      state: 'enroll-programme',
    },
  };

  // set cta text
  useEffect(() => {
    switch (mediaType) {
      case 'programme':
        if (mediaObject.progress === 0 || !mediaObject.progress) {
          setActiveDay(mediaObject.days[0]);
          setCta(`${t('M070W')}`);
        } else if (Math.ceil(mediaObject.progress) === 100) {
          setActiveDay(mediaObject.days[0]);
          setCta(`${t('M074W')}`);
        } else {
          let lastCompletedIndex;
          for (let i = 0; i < mediaObject.days.length; i++) {
            if (mediaObject.days[i].completed === true) {
              lastCompletedIndex = i;
            }
          }
          if (lastCompletedIndex === undefined) {
            setActiveDay(mediaObject.days[0]);
            setCta(mediaObject.days[0]?.progress === 0 ? `${t('M069W')} 1` : `${t('M068W')} 1`);
          } else if (mediaObject.days[lastCompletedIndex + 1]?.progress === 0) {
            setActiveDay(mediaObject.days[lastCompletedIndex + 1]);
            setCta(`${t('M069W')} ${lastCompletedIndex + 2}`);
          } else {
            setActiveDay(mediaObject.days[lastCompletedIndex + 1]);
            setCta(`${t('M068W')} ${lastCompletedIndex + 2}`);
          }
        }
        break;
      case 'masterclass': {
        let indexToPlay = mediaObject.progress_array.findIndex((item) => Math.ceil(item) < 100);

        if (indexToPlay === -1) {
          // If all chapters are completed or not started, start at the beginning
          indexToPlay = 0;
        }

        if (
          mediaObject.progress_array[indexToPlay] > 0 &&
          Math.ceil(mediaObject.progress_array[indexToPlay]) < 100
        ) {
          setCta(`${t('M064W')} ${indexToPlay + 1}`);
          setIndexToBePlayed(indexToPlay);
        } else {
          setCta(`${t('M065W')} ${indexToPlay + 1}`);
          setIndexToBePlayed(indexToPlay);
        }
        break;
      }

      default:
        if (mediaObject.category === 'workout') {
          if (mediaObject.progress && Math.ceil(mediaObject.progress) < 100) {
            setCta(t('M056'));
          } else if (mediaObject.progress && Math.ceil(mediaObject.progress) === 100) {
            setCta(t('M056W'));
          } else {
            setCta(t('M055'));
          }
        } else if (mediaObject.type === 'audio') {
          if (
            mediaObject.progress &&
            mediaObject.progress > 0 &&
            Math.ceil(mediaObject.progress) < 100
          ) {
            setCta(t('M024'));
          } else if (mediaObject.progress && Math.ceil(mediaObject.progress) === 100) {
            setCta(t('M075'));
          } else {
            setCta(t('M023'));
          }
        } else if (mediaObject.type === 'video') {
          if (mediaObject.progress && Math.ceil(mediaObject.progress) < 100) {
            setCta(t('M048'));
          } else if (mediaObject.progress && Math.ceil(mediaObject.progress) === 100) {
            setCta(t('M071W'));
          } else {
            setCta(t('M035'));
          }
        }
        break;
    }
  }, [mediaObject, mediaType, setActiveDay, t]);

  const checkRestartProg = () => {
    setOpenPopUp(true);
  };

  return (
    <>
      {openPopUp && (
        <WhitePopUpWithLinks
          popUpContents={popUpContents}
          dialogTitle={t('modal.reenroll.information')}
        />
      )}
      {mediaType === 'programme' && (
        <div className="cta-block">
          <div className="cta-container">
            {cta && <CtaContent cta={cta} mediaUrl={mediaUrl} onRestart={checkRestartProg} />}
          </div>
        </div>
      )}
      {mediaType === 'masterclass' && (
        <div className="cta-block">
          <div className="cta-container">
            {mediaUrl && cta && (
              <Link to={mediaUrl} className="cta-button hero-button hero-link" id="hero-button">
                {cta}
              </Link>
            )}
          </div>
        </div>
      )}
      {!mediaObject.chid.startsWith('TA') &&
        mediaObject.category !== 'service' &&
        mediaObject.type && (
          <div className="cta-block">
            <div className="cta-container">
              {cta && mediaUrl && (
                <Link to={mediaUrl} className="cta-button hero-button hero-link" id="hero-button">
                  {cta}
                </Link>
              )}
            </div>
          </div>
        )}
      {(mediaObject.chid.startsWith('TA') || mediaObject.category === 'service') && (
        <div className="cta-block service">
          <div className="cta-container">
            {mediaObject.action_url && (
              <a
                href={mediaObject.action_url}
                target={
                  mediaObject.action_url.includes(process.env.REACT_APP_HOST) ? '_self' : '_blank'
                }
                rel="noreferrer noopener"
                className="cta-button hero-button hero-link take-action"
              >
                {mediaObject.action_string}
                {!mediaObject.action_url.includes(process.env.REACT_APP_HOST) && (
                  <span className="sr-only">${t('external.link.label.newTab')}</span>
                )}
              </a>
            )}{' '}
            {(mediaObject.type || (mediaType === 'take-actions' && mediaObject.media)) &&
              mediaUrl && (
                <Link to={mediaUrl} className="cta-button hero-button hero-link" id="hero-button">
                  <FontAwesomeIcon icon={faVolumeSharp} className="hero-link-icon" />
                  {t('M026')}
                </Link>
              )}
          </div>
        </div>
      )}
    </>
  );
}

function CtaContent({ cta, mediaUrl, onRestart }) {
  const { t } = useTranslation();

  if (cta === `${t('M074W')}`) {
    return (
      <Button className="cta-button hero-button" id="hero-button" onClick={onRestart}>
        {cta}
      </Button>
    );
  }
  if (mediaUrl) {
    return (
      <Link to={mediaUrl} className="cta-button hero-button hero-link" id="hero-button">
        {cta}
      </Link>
    );
  }
  return null;
}
